// extracted by mini-css-extract-plugin
export var aiStarIcon = "_a6-4";
export var closeButton = "_a6-6";
export var dismissButton = "_a6-3";
export var editImageWithAiContainer = "_a6-8";
export var imageUploadWrapper = "_a6-7";
export var misspelledWord = "_a6-5";
export var spellCheckContainer = "_a6-2";
export var spin = "_a6-1";
export var spinning = "_a6-0";